import { combineReducers } from "redux";
import { billingReducer } from "./billing";
import { permissionsReducer } from "./permissions";

export const meteringReducer = combineReducers({
    billing: billingReducer,
    permissions: permissionsReducer
});
